import { render } from "./Employee.vue?vue&type=template&id=01af4ed6"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=01af4ed6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__